import runtimeEnv from './runtimeEnv';

export const defaultDocsSiteURL = 'https://docs.datafy.io/';

export function getDocsSiteURL(): string {
  return runtimeEnv.docsSiteURL ?? defaultDocsSiteURL;
}
